// eslint-disable-next-line no-restricted-imports
import RNDeviceInfo from 'react-native-device-info'
import * as Crypto from 'expo-crypto'
import PackageJson from '../../package.json'

// Note that this "deviceId" will be specific to the browser or device and will change if the user clears their browser data or switches devices.
const deviceId = Crypto.randomUUID()

const DeviceInfo = {
  ...RNDeviceInfo,

  getUniqueId: () => {
    const uniqueId = RNDeviceInfo.getUniqueIdSync()
    if (uniqueId === undefined || uniqueId === 'unknown') {
      return deviceId
    }
    return uniqueId
  },

  getVersion: () => {
    const appVersion = RNDeviceInfo.getVersion()
    if (!appVersion || appVersion === 'unknown') {
      return PackageJson.version
    }
    return appVersion
  },
}

export default DeviceInfo
